module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjMiIGhlaWdodD0iMTIzIiB2aWV3Qm94PSIwIDAgMTIzIDEyMyI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IHdpZHRoPSIxMjMiIGhlaWdodD0iMTIzIiBmaWxsPSIjNURCMzQ4IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHJ4PSI0Ii8+CiAgICAgICAgPHBhdGggc3Ryb2tlPSIjRkZGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZD0iTTM0LjQ0IDYzLjgzN2wxNi40IDE2LjQgMzcuOTI1LTM3LjkyNSIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/answer-yes-selected-small.svg
// module id = 2686
// module chunks = 0